import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './App.css';

function App() {
  const [phones, setPhones] = useState([]);
  const [form, setForm] = useState({ name: '', price: '', description: '' });
  const [editingId, setEditingId] = useState(null);

  const API_URL = 'https://phone-shop-dbua.onrender.com';

  useEffect(() => {
    fetchPhones();
  }, []);

  const fetchPhones = async () => {
    try {
      const res = await axios.get(`${API_URL}/phones`);
      setPhones(res.data);
    } catch (err) {
      console.log('Lỗi fetch:', err);
    }
  };

  const handleSubmit = async () => {
    if (!form.name || !form.price) {
      alert('Vui lòng nhập tên và giá');
      return;
    }

    try {
      if (editingId) {
        const res = await axios.put(`${API_URL}/phones/${editingId}`, form);
        setPhones(phones.map(p => (p._id === editingId ? res.data : p)));
        setEditingId(null);
      } else {
        const res = await axios.post(`${API_URL}/phones`, form);
        setPhones([...phones, res.data]);
      }
      setForm({ name: '', price: '', description: '' });
    } catch (err) {
      console.log('Lỗi submit:', err);
    }
  };

  const startEdit = (phone) => {
    setForm({ name: phone.name, price: phone.price, description: phone.description });
    setEditingId(phone._id);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Xóa sản phẩm này?')) {
      try {
        await axios.delete(`${API_URL}/phones/${id}`);
        setPhones(phones.filter(p => p._id !== id));
      } catch (err) {
        console.log('Lỗi xóa:', err);
      }
    }
  };

  return (
    <div className="App">
      <h1>🛒 Cửa Hàng Điện Thoại</h1>

      <div className="form-container">
        <input
          placeholder="Tên điện thoại"
          value={form.name}
          onChange={e => setForm({ ...form, name: e.target.value })}
        />
        <input
          placeholder="Giá (VND)"
          type="number"
          value={form.price}
          onChange={e => setForm({ ...form, price: e.target.value })}
        />
        <input
          placeholder="Mô tả"
          value={form.description}
          onChange={e => setForm({ ...form, description: e.target.value })}
        />
        <button className="btn-primary" onClick={handleSubmit}>
          {editingId ? '✓ Cập nhật' : '+ Thêm sản phẩm'}
        </button>
        {editingId && (
          <button 
            className="btn-secondary"
            onClick={() => {
              setEditingId(null);
              setForm({ name: '', price: '', description: '' });
            }}
          >
            ✕ Hủy
          </button>
        )}
      </div>

      <h2>📱 Danh sách sản phẩm</h2>
      {phones.length === 0 ? (
        <div className="empty-state">
          Chưa có sản phẩm nào. Hãy thêm sản phẩm đầu tiên!
        </div>
      ) : (
        <ul>
          {phones.map(phone => (
            <li key={phone._id}>
              <strong>{phone.name}</strong>
              <div className="price">{phone.price.toLocaleString()} VND</div>
              {phone.description && (
                <div className="description">📝 {phone.description}</div>
              )}
              <div className="button-group">
                <button className="btn-edit" onClick={() => startEdit(phone)}>
                  ✎ Sửa
                </button>
                <button className="btn-delete" onClick={() => handleDelete(phone._id)}>
                  🗑 Xóa
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default App;